
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Award } from "lucide-react";

const EducationTimeline = () => {
  return (
    <Card className="border-none shadow-md mb-8">
      <CardContent className="pt-6">
        <h3 className="text-xl font-medium mb-4 text-center flex items-center justify-center gap-2">
          <Award className="h-5 w-5 text-kaija-slate" /> 
          Täiendkoolitus
        </h3>
        <div className="w-12 h-1 bg-kaija-slate/60 rounded-full mx-auto mb-6"></div>
        
        <div className="space-y-8">
          {/* Timeline-style education layout */}
          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-0 top-0 h-full w-0.5 bg-kaija-slate/20 ml-3"></div>
            
            <div className="space-y-10">
              {/* 2024 December */}
              <div className="relative pl-12">
                <div className="absolute left-0 top-1 w-6 h-6 rounded-full bg-kaija-peach flex items-center justify-center">
                  <div className="w-3 h-3 rounded-full bg-kaija-slate"></div>
                </div>
                <div className="flex flex-col">
                  <span className="text-kaija-slate font-medium">Detsember 2024</span>
                  <h4 className="font-medium mt-1">Nartsissistliku väärkohtlemise spetsialist</h4>
                  <p className="text-gray-700 mt-1">
                    Narcissistic Abuse Specialist, CPD Accredited – (The School of Trauma Informed Positive Psychology)
                  </p>
                </div>
              </div>
              
              {/* 2024 August */}
              <div className="relative pl-12">
                <div className="absolute left-0 top-1 w-6 h-6 rounded-full bg-kaija-peach flex items-center justify-center">
                  <div className="w-3 h-3 rounded-full bg-kaija-slate"></div>
                </div>
                <div className="flex flex-col">
                  <span className="text-kaija-slate font-medium">August 2024</span>
                  <h4 className="font-medium mt-1">Hüpnoterapeut</h4>
                  <p className="text-gray-700 mt-1">
                    Hypnotherapy practitioner, registreeritud American Board of Hypnotherapy's (The School of Trauma Informed Positive Psychology)
                  </p>
                </div>
              </div>
              
              {/* 2023-2024 */}
              <div className="relative pl-12">
                <div className="absolute left-0 top-1 w-6 h-6 rounded-full bg-kaija-peach flex items-center justify-center">
                  <div className="w-3 h-3 rounded-full bg-kaija-slate"></div>
                </div>
                <div className="flex flex-col">
                  <span className="text-kaija-slate font-medium">November 2023 - Märts 2024</span>
                  <h4 className="font-medium mt-1">Somatic Trauma Informed Coaching & Leadership Certification</h4>
                  <p className="text-gray-700 mt-1">
                    ICF ja CPD accredited, (The School of Trauma Informed Positive Psychology)
                  </p>
                </div>
              </div>
              
              {/* 2017-2019 */}
              <div className="relative pl-12">
                <div className="absolute left-0 top-1 w-6 h-6 rounded-full bg-kaija-peach flex items-center justify-center">
                  <div className="w-3 h-3 rounded-full bg-kaija-slate"></div>
                </div>
                <div className="flex flex-col">
                  <span className="text-kaija-slate font-medium">2017 - 2019</span>
                  <div className="space-y-3 mt-1">
                    <div>
                      <h4 className="font-medium">Lahenduskeskne Coach</h4>
                      <p className="text-gray-700">
                        Erickson Coaching International, The Art and Science of Coaching Modules. Erickson Professional Coach, ICF accredited. The Art and Science of Coaching, Solution-Focused Coach Training.
                      </p>
                    </div>
                    <div>
                      <h4 className="font-medium">High Performance Team Coach</h4>
                      <p className="text-gray-700">
                        Erickson Coaching International, ICF Accredited Continuing Coach Education Program.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* 2018 */}
              <div className="relative pl-12">
                <div className="absolute left-0 top-1 w-6 h-6 rounded-full bg-kaija-peach flex items-center justify-center">
                  <div className="w-3 h-3 rounded-full bg-kaija-slate"></div>
                </div>
                <div className="flex flex-col">
                  <span className="text-kaija-slate font-medium">2018</span>
                  <h4 className="font-medium mt-1">Vaikuseminutite teadveloleku kursus</h4>
                </div>
              </div>
            </div>
          </div>
          
          <div className="text-center mt-6 pt-4 border-t border-gray-100">
            <p className="text-gray-700 italic">
              Hetkel käsil õppeprogramm Positiivse Psühholoogia osas.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default EducationTimeline;
